import dayjs from "dayjs";
import { Typography } from "@mui/joy";
import {
  IonCard,
  IonCardContent,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonRow,
} from "@ionic/react";
import { callSharp, logoWhatsapp, homeOutline } from "ionicons/icons";
import ModernDesplegable from "../../components/basicsComponents/ModernDesplegable/ModernDesplegable";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import "./turno-button.css";
import "./turno-rango-button.css";
import "./NuevoTurnoConfirmacionModal.css";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import {
  Column,
  Container,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import CustomCalendar from "../../components/basicsComponents/Calendar";
import { obtenerNombreDia } from "../../utils/funcionalidadesStrings";
import useTituloPagina from "../../hooks/tituloPagina";
import { useNuevoTurno } from "./useNuevoTurno";

import { useEffect, useState, useRef } from "react";
import { useHorariosPrestador } from "./useHorariosPrestador";

function NuevoTurno() {
  useTituloPagina();
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastColor, setToastColor] = useState("");

  const mostrarNotificacion = (open, mensaje, color) => {
    setOpenToast(open);
    setToastMessage(mensaje);
    setToastColor(color);
  };

  const {
    usuario,
    urlAxioPP,
    cargando,
    especialidadesDesplegable,
    prestadoresDesplegable,
    especialidadSeleccionada,
    prestadorSeleccionado,
    fechasFuturas,
    fechaSeleccionada,
    turnosDisponibles,
    turnoSeleccionado,
    notaWebMutual,
    mostrarInasisEspecilidad,
    mostrarTurnoPrestadorReservado,
    abrirDesplegableEspecialidades,
    abrirDesplegablePrestadores,
    abrirModalConfirmarReserva,
    abrirModalPostReserva,
    setFechaSeleccionada,
    setAbrirDesplegableEspecialidades,
    setAbrirDesplegablePrestadores,
    setAbrirModalConfirmarReserva,
    setAbrirModalPostReserva,
    handleChangeSelect,
    handleChangeFecha,
    handleClickSeleccionarTurno,
    handleClickConfirmarHacerReserva,
    handleClickCopiarTelefono,
    handlePostTurnoReservado,
    getPrestadorSeleccionadoData,
  } = useNuevoTurno(mostrarNotificacion);

  const prestadorData = getPrestadorSeleccionadoData();
  const notaWebPrestador = (
    prestadorData?.notaWeb ||
    prestadorData?.NotaWeb ||
    ""
  ).trim();
  const ocultarSelectorEspecialidad = especialidadesDesplegable.length === 1;
  const anchoContenidoPrincipal =
    window.innerWidth >= 1200 ? "1260px" : "960px";
  const columnasAgenda =
    window.innerWidth >= 1024
      ? "minmax(350px, 0.88fr) minmax(560px, 1.38fr)"
      : window.innerWidth >= 768
        ? "1fr 1fr"
        : "1fr";

  // Ref para trackear el último prestador cargado y evitar reseteos innecesarios
  const ultimoPrestadorCargado = useRef(null);

  // Solo seleccionar fecha automáticamente cuando cambia el prestador (no cuando el usuario navega el calendario)
  useEffect(() => {
    // Solo actuar si cambió el prestador y hay turnos disponibles
    if (
      prestadorSeleccionado !== -1 &&
      prestadorSeleccionado !== ultimoPrestadorCargado.current &&
      turnosDisponibles.length > 0
    ) {
      ultimoPrestadorCargado.current = prestadorSeleccionado;

      // Seleccionar la primera fecha con turnos disponibles
      const primeraFechaTurno = turnosDisponibles[0]?.fecha;
      if (primeraFechaTurno) {
        setFechaSeleccionada(dayjs(primeraFechaTurno).format("YYYY-MM-DD"));
      } else if (fechasFuturas[0]) {
        setFechaSeleccionada(dayjs(fechasFuturas[0]).format("YYYY-MM-DD"));
      }
    }
  }, [
    prestadorSeleccionado,
    turnosDisponibles,
    fechasFuturas,
    setFechaSeleccionada,
  ]);
  // Hook para obtener los horarios del prestador seleccionado
  // Extraer solo el código numérico del prestador para el hook
  const prestadorCodigoSolo =
    typeof prestadorSeleccionado === "string"
      ? prestadorSeleccionado.split("-")[0]
      : prestadorSeleccionado;
  const baseUrlHorarios = urlAxioPP || process.env.REACT_APP_API_URL;
  const { horariosPrestador, cargandoHorarios } = useHorariosPrestador(
    prestadorCodigoSolo,
    usuario,
    baseUrlHorarios,
  );

  // Utilidad para obtener el rango total de horarios del prestador para el día seleccionado
  // Extrae horarios del formato "De HH:mm a HH:mm" y genera intervalos de 15 minutos desde horariosPrestador
  const getRangoHorariosPrestador = () => {
    if (!horariosPrestador || !fechaSeleccionada) return [];
    console.log("🔍 [DEBUG] horariosPrestador completo:", horariosPrestador);
    const diasMap = {
      // Español
      domingo: "domingo",
      lunes: "lunes",
      martes: "martes",
      miércoles: "miercoles",
      miercoles: "miercoles",
      jueves: "jueves",
      viernes: "viernes",
      sábado: "sabado",
      sabado: "sabado",
      // Inglés (por si dayjs no toma locale es)
      sunday: "domingo",
      monday: "lunes",
      tuesday: "martes",
      wednesday: "miercoles",
      thursday: "jueves",
      friday: "viernes",
      saturday: "sabado",
    };
    const diaSemana = dayjs(fechaSeleccionada)
      .locale("es")
      .format("dddd")
      .toLowerCase();
    const diaKey = diasMap[diaSemana] || diaSemana;
    console.log("🔍 [DEBUG] Día de la semana:", diaSemana, "- Clave:", diaKey);
    // Ejemplo: martesM, martesT
    const bloques = [`${diaKey}M`, `${diaKey}T`];
    let horarios = [];
    bloques.forEach((b) => {
      const franja = horariosPrestador[b];
      console.log(`🔍 [DEBUG] Bloque ${b}:`, franja);
      if (
        franja &&
        typeof franja === "string" &&
        franja.includes("De") &&
        franja.includes("a")
      ) {
        // Extraer "De HH:mm a HH:mm"
        const match = franja.match(/De (\d{2}:\d{2}) a (\d{2}:\d{2})/);
        if (match) {
          let h = dayjs(match[1], "HH:mm");
          const hHasta = dayjs(match[2], "HH:mm");
          while (h.isBefore(hHasta) || h.isSame(hHasta)) {
            horarios.push(h.format("HH:mm"));
            h = h.add(15, "minute");
          }
        }
      }
    });
    console.log(
      "🔍 [DEBUG] Horarios generados (intervalos de 15 min):",
      horarios,
    );
    return horarios;
  };

  // Obtener los horarios disponibles para la fecha seleccionada
  const horariosDisponibles = turnosDisponibles
    .filter(
      (turno) =>
        dayjs(turno.fecha).format("YYYY-MM-DD") ===
        dayjs(fechaSeleccionada).format("YYYY-MM-DD"),
    )
    .map((turno) => dayjs(turno.hora).format("HH:mm"));

  const [horariosMerged, setHorariosMerged] = useState([]);

  useEffect(() => {
    const normalize = (h) => {
      const d = dayjs(h, "HH:mm", true);
      return d.isValid() ? d.format("HH:mm") : null;
    };
    const rango = getRangoHorariosPrestador().map(normalize).filter(Boolean);
    const disponiblesNorm = horariosDisponibles.map(normalize).filter(Boolean);
    const merged = Array.from(new Set([...rango, ...disponiblesNorm])).sort(
      (a, b) => dayjs(a, "HH:mm").valueOf() - dayjs(b, "HH:mm").valueOf(),
    );

    if (merged.length === 0) {
      if (cargandoHorarios) {
        setHorariosMerged(["__loading"]);
        return;
      }
      if (turnosDisponibles.length > 0) {
        setHorariosMerged(["__fallback-turnos"]);
        return;
      }
      setHorariosMerged(["__sin-horarios"]);
      return;
    }
    setHorariosMerged(merged);
  }, [
    horariosPrestador,
    fechaSeleccionada,
    horariosDisponibles,
    cargandoHorarios,
    turnosDisponibles,
  ]);

  const handleVolverInicio = () => {
    window.location.href = "/portal/Inicio";
  };

  return (
    <>
      <div slot="content">
        <Container>
          {/* Header con título y botón volver - alineado con los desplegables */}
          <Row
            container
            width="100%"
            style={{ marginTop: "24px", marginBottom: "16px" }}
          >
            <Column xs={12}>
              <div
                style={{
                  maxWidth: anchoContenidoPrincipal,
                  margin: "0 auto",
                  display: "flex",
                  flexDirection: window.innerWidth < 768 ? "column" : "row",
                  alignItems: window.innerWidth < 768 ? "stretch" : "center",
                  justifyContent: "space-between",
                  gap: "12px",
                  padding: "0 8px",
                }}
              >
                <Typography
                  level="h2"
                  sx={{
                    fontSize: { xs: "1.3rem", md: "1.6rem" },
                    fontWeight: 700,
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Reserva de Turnos
                </Typography>
                <button
                  onClick={handleVolverInicio}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    padding: "12px 20px",
                    backgroundColor: "white",
                    border: "2px solid #667eea",
                    borderRadius: "12px",
                    color: "#667eea",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 8px rgba(102, 126, 234, 0.10)",
                    minWidth: "fit-content",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#667eea";
                    e.target.style.color = "white";
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow =
                      "0 4px 12px rgba(102, 126, 234, 0.18)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "white";
                    e.target.style.color = "#667eea";
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow =
                      "0 2px 8px rgba(102, 126, 234, 0.10)";
                  }}
                >
                  <IonIcon icon={homeOutline} style={{ fontSize: "18px" }} />
                  <span>Volver al inicio</span>
                </button>
              </div>
            </Column>
          </Row>

          {/* Desplegables de especialidad y profesional */}
          <Row
            container
            width="100%"
            style={{ marginTop: "16px", marginBottom: "8px" }}
          >
            <Column xs={12}>
              <div
                style={{
                  maxWidth: anchoContenidoPrincipal,
                  margin: "0 auto",
                  padding: "0 8px",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      window.innerWidth >= 768 ? "1fr 1fr" : "1fr",
                    gap: "12px",
                  }}
                >
                  {!ocultarSelectorEspecialidad && (
                    <IonItem
                      className="ion-item-no-border"
                      style={{ width: "100%", maxWidth: "100%" }}
                    >
                      <ModernDesplegable
                        array={especialidadesDesplegable}
                        value={especialidadSeleccionada}
                        handleChange={handleChangeSelect}
                        placeholder="Seleccione una especialidad..."
                        label="Especialidad"
                        id="Especialidad"
                        isOpen={abrirDesplegableEspecialidades}
                        setIsOpen={setAbrirDesplegableEspecialidades}
                        disabled={cargando}
                        emoji="🏥"
                        color="#667eea"
                      />
                    </IonItem>
                  )}
                  {especialidadSeleccionada !== -1 && (
                    <IonItem
                      className="ion-item-no-border"
                      style={{ width: "100%", maxWidth: "100%" }}
                    >
                      <ModernDesplegable
                        array={prestadoresDesplegable}
                        value={prestadorSeleccionado}
                        handleChange={handleChangeSelect}
                        placeholder="Seleccione un profesional..."
                        label="Profesional"
                        id="Profesional"
                        isOpen={abrirDesplegablePrestadores}
                        setIsOpen={setAbrirDesplegablePrestadores}
                        disabled={cargando || especialidadSeleccionada === -1}
                        emoji="👨‍⚕️"
                        color="#fe506ca1"
                      />
                    </IonItem>
                  )}
                </div>
              </div>
            </Column>
          </Row>
        </Container>
        {especialidadSeleccionada !== -1 &&
          prestadorSeleccionado !== -1 &&
          notaWebPrestador && (
            <Container>
              <Row container width="100%" style={{ marginBottom: "16px" }}>
                <Column xs={12}>
                  <div
                    style={{
                      maxWidth: anchoContenidoPrincipal,
                      margin: "0 auto",
                      padding: "0 8px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "14px",
                        padding:
                          window.innerWidth < 768 ? "12px 14px" : "14px 18px",
                        background:
                          "linear-gradient(135deg, rgba(58, 61, 153, 0.94) 0%, rgba(81, 83, 179, 0.94) 100%)",
                        boxShadow: "0 8px 22px rgba(58, 61, 153, 0.20)",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: window.innerWidth < 768 ? "0.92rem" : "1rem",
                        lineHeight: 1.45,
                      }}
                    >
                      {notaWebPrestador}
                    </div>
                  </div>
                </Column>
              </Row>
            </Container>
          )}
        {especialidadSeleccionada !== -1 &&
          prestadorSeleccionado !== -1 &&
          notaWebMutual && (
            <Container>
              <Row container width="100%" style={{ marginBottom: "16px" }}>
                <Column xs={12}>
                  <div
                    style={{
                      maxWidth: anchoContenidoPrincipal,
                      margin: "0 auto",
                      padding: "0 8px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "14px",
                        padding:
                          window.innerWidth < 768 ? "12px 14px" : "14px 18px",
                        background:
                          "linear-gradient(135deg, rgba(254, 80, 108, 0.92) 0%, rgba(255, 134, 153, 0.92) 100%)",
                        boxShadow: "0 8px 22px rgba(254, 80, 108, 0.22)",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: window.innerWidth < 768 ? "0.92rem" : "1rem",
                        lineHeight: 1.45,
                      }}
                    >
                      {notaWebMutual}
                    </div>
                  </div>
                </Column>
              </Row>
            </Container>
          )}
        {fechasFuturas.length > 0 && (
          <IonGrid style={{ padding: "0", marginTop: "-4px" }}>
            <IonRow
              style={{
                gap: "12px",
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              <IonCol
                size="12"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div
                  style={{
                    width: "100%",
                    maxWidth: anchoContenidoPrincipal,
                    margin: "0 auto",
                    padding: "0 8px",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: columnasAgenda,
                      gap: "16px",
                      alignItems: "stretch",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        maxWidth: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifySelf: "start",
                      }}
                    >
                      <CustomCalendar
                        onChange={(newSelectedDate) =>
                          handleChangeFecha(
                            dayjs(newSelectedDate).format("YYYY-MM-DD"),
                          )
                        }
                        minDate={dayjs(new dayjs())}
                        maxDate={dayjs(new dayjs()).add(3, "months")}
                        value={fechaSeleccionada}
                        highlightedDates={fechasFuturas}
                      />
                    </div>
                    <div
                      style={{
                        width: "100%",
                        maxWidth: "100%",
                        height: "100%",
                        justifySelf: "start",
                      }}
                    >
                      <div
                        style={{
                          background: "white",
                          borderRadius: "16px",
                          padding: "16px",
                          boxShadow: "0 4px 12px rgba(102, 126, 234, 0.1)",
                          maxWidth: "100%",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
                            border: "1px solid rgba(102, 126, 234, 0.2)",
                            borderRadius: "12px",
                            padding: "12px",
                            marginBottom: "12px",
                            boxShadow: "0 2px 8px rgba(102, 126, 234, 0.08)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              marginBottom: "6px",
                            }}
                          >
                            <span style={{ fontSize: "20px" }}>📅</span>
                            <Typography
                              level="h4"
                              sx={{
                                background:
                                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                fontWeight: 800,
                                fontSize: "16px",
                                margin: 0,
                                textTransform: "capitalize",
                              }}
                            >
                              {`${obtenerNombreDia(
                                dayjs(fechaSeleccionada).format("dddd"),
                              )} ${dayjs(fechaSeleccionada).format("DD")} de ${dayjs(
                                fechaSeleccionada,
                              ).format("MMMM, YYYY")}`}
                            </Typography>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <span style={{ fontSize: "14px" }}>⏰</span>
                            <Typography
                              level="body-sm"
                              sx={{
                                color: "#6b7280",
                                fontWeight: 600,
                                fontSize: "13px",
                              }}
                            >
                              {"Horarios disponibles"}
                            </Typography>
                          </div>
                        </div>
                        <div
                          style={{
                            background: "#fafbfc",
                            border: "1px solid rgba(102, 126, 234, 0.15)",
                            borderRadius: "12px",
                            padding: "12px",
                            flex: 1,
                          }}
                        >
                          <IonGrid>
                            <IonRow style={{ flexWrap: "wrap", gap: "4px" }}>
                              {/* Mostrar rango del prestador (gris) + disponibles (violeta) sin requerir click */}
                              {horariosMerged.map((hora, idx) => {
                                if (hora === "__loading") {
                                  return (
                                    <Typography
                                      key="loading"
                                      level="body-sm"
                                      sx={{
                                        color: "#6b7280",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      Cargando horarios...
                                    </Typography>
                                  );
                                }
                                if (hora === "__fallback-turnos") {
                                  return null;
                                }
                                if (hora === "__sin-horarios") {
                                  return (
                                    <Typography
                                      key="sin-horarios"
                                      level="body-sm"
                                      sx={{
                                        color: "#6b7280",
                                        padding: "4px 8px",
                                      }}
                                    >
                                      Sin horarios configurados para este día
                                    </Typography>
                                  );
                                }

                                const esDisponible =
                                  horariosDisponibles.includes(hora);
                                if (esDisponible) {
                                  return (
                                    <button
                                      key={"disp-" + hora + idx}
                                      onClick={() => {
                                        const turno = turnosDisponibles.find(
                                          (t) =>
                                            dayjs(t.hora).format("HH:mm") ===
                                              hora &&
                                            dayjs(t.fecha).format(
                                              "YYYY-MM-DD",
                                            ) ===
                                              dayjs(fechaSeleccionada).format(
                                                "YYYY-MM-DD",
                                              ),
                                        );
                                        if (turno)
                                          handleClickSeleccionarTurno(turno);
                                      }}
                                      className="turno-button"
                                      style={{
                                        padding: "8px 14px",
                                        fontSize: "0.95rem",
                                        borderRadius: "12px",
                                        margin: "0 6px 8px 0",
                                      }}
                                    >
                                      {hora}
                                    </button>
                                  );
                                }
                                return (
                                  <button
                                    key={"rango-" + hora + idx}
                                    className="turno-rango-button"
                                    tabIndex={-1}
                                    disabled
                                  >
                                    {hora}
                                  </button>
                                );
                              })}
                            </IonRow>
                          </IonGrid>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        )}
      </div>
      {mostrarInasisEspecilidad && (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard color="warning">
              <IonCardContent>
                <h4 className="main-content">
                  ⚠ No podes reservar un nuevo turno con esta especialidad
                  debido a que no asististe a 2 o mas turnos en los ultimos 2
                  meses para la especialidad que seleccionaste. Estaremos
                  encantados de atenderte y brindarte la mejor atención
                  personalizada si te pones en contacto. Podes presionar los
                  botones inferiores para copiar el numero de telefono fijo o
                  llevarte a nuestro chat de Whatsapp.
                </h4>
              </IonCardContent>
              <IonRow>
                <IonCol>
                  <StyledButton className="verde" expand="block">
                    <IonIcon icon={logoWhatsapp} />
                    <IonLabel>WhatsApp</IonLabel>
                  </StyledButton>
                </IonCol>
                <IonCol>
                  <StyledButton
                    className="blanco"
                    expand="block"
                    onClick={handleClickCopiarTelefono}
                  >
                    <IonIcon icon={callSharp} />
                    <IonLabel>Telefono</IonLabel>
                  </StyledButton>
                </IonCol>
              </IonRow>
            </IonCard>
          </IonCol>
        </IonRow>
      )}
      {mostrarTurnoPrestadorReservado && (
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonCard color="warning">
              <IonCardContent>
                <h4 className="main-content">
                  ⚠ No esta permitido sacar un segundo turno para un mismo
                  prestador
                </h4>
              </IonCardContent>
            </IonCard>
          </IonCol>
        </IonRow>
      )}
      {prestadorSeleccionado !== -1 && (
        <DialogoConfirmacion
          titulo="Reservar turno"
          texto="Revisá los datos del turno antes de confirmarlo."
          contenido={
            <div className="nt-confirm-modal">
              <div className="nt-confirm-header">
                <span className="nt-confirm-title">Resumen del turno</span>
              </div>
              <div className="nt-confirm-grid">
                <div className="nt-confirm-field">
                  <span className="nt-confirm-label">Profesional</span>
                  <span className="nt-confirm-value">
                    {turnoSeleccionado.prestadorNom}
                  </span>
                </div>
                <div className="nt-confirm-field">
                  <span className="nt-confirm-label">Especialidad</span>
                  <span className="nt-confirm-value">
                    {turnoSeleccionado.especialidadNom}
                  </span>
                </div>
                <div className="nt-confirm-field">
                  <span className="nt-confirm-label">Fecha</span>
                  <span className="nt-confirm-value">
                    {dayjs(turnoSeleccionado.fecha).format("DD/MM/YYYY")}
                  </span>
                </div>
                <div className="nt-confirm-field">
                  <span className="nt-confirm-label">Hora</span>
                  <span className="nt-confirm-value">
                    {dayjs(turnoSeleccionado.hora).format("HH:mm")}
                  </span>
                </div>
              </div>
              <div className="nt-confirm-section">
                <span className="nt-confirm-section-title">
                  Datos del paciente
                </span>
                <div className="nt-confirm-grid">
                  <div className="nt-confirm-field">
                    <span className="nt-confirm-label">Nombre</span>
                    <span className="nt-confirm-value">
                      {usuario?.nombre || "-"}
                    </span>
                  </div>
                  <div className="nt-confirm-field">
                    <span className="nt-confirm-label">Apellido</span>
                    <span className="nt-confirm-value">
                      {usuario?.apellido || "-"}
                    </span>
                  </div>
                  <div className="nt-confirm-field">
                    <span className="nt-confirm-label">Documento</span>
                    <span className="nt-confirm-value">
                      {usuario?.documentoNro || "-"}
                    </span>
                  </div>
                  <div className="nt-confirm-field">
                    <span className="nt-confirm-label">Obra social</span>
                    <span className="nt-confirm-value">
                      {usuario?.mutualNombre || "-"}
                    </span>
                  </div>
                  <div className="nt-confirm-field">
                    <span className="nt-confirm-label">Nro. afiliado</span>
                    <span className="nt-confirm-value">
                      {usuario?.mutualAfiliado || "-"}
                    </span>
                  </div>
                  <div className="nt-confirm-field">
                    <span className="nt-confirm-label">Celular</span>
                    <span className="nt-confirm-value">
                      {usuario?.celular || "-"}
                    </span>
                  </div>
                  <div className="nt-confirm-field">
                    <span className="nt-confirm-label">Correo</span>
                    <span className="nt-confirm-value">
                      {usuario?.email || "-"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="nt-confirm-note">
                Si algún dato no es correcto, presioná “No, Revisar”.
              </div>
            </div>
          }
          open={abrirModalConfirmarReserva}
          setOpen={setAbrirModalConfirmarReserva}
          handleClickConfirmar={handleClickConfirmarHacerReserva}
          colorBotonNo="danger"
          colorBotonSi="success"
          textoBotonNo="No, Revisar"
          textoBotonSi="Si, Confirmar"
        />
      )}

      {prestadorSeleccionado !== -1 && (
        <DialogoConfirmacion
          titulo="Turno reservado"
          texto={`Se ha reservado exitosamente el turno con el/la profesional ${
            turnoSeleccionado.prestadorNom
          }, con especialidad en ${
            turnoSeleccionado.especialidadNom
          }, para el día ${dayjs(turnoSeleccionado.fecha).format(
            "DD/MM/YYYY",
          )}, a las ${dayjs(turnoSeleccionado.hora).format("HH:mm")}`}
          open={abrirModalPostReserva}
          setOpen={setAbrirModalPostReserva}
          handleClickConfirmar={() => handlePostTurnoReservado("nuevoTurno")}
          handleClickCancelar={() => handlePostTurnoReservado("turnosPaciente")}
          variantBotonNo="solid"
          colorBotonNo="primary"
          variantBotonSi="solid"
          colorBotonSi="primary"
          variantDialog="plain"
          colorDialogo="success"
          textoBotonNo="Consultar mis turnos"
          textoBotonSi="Reservar nuevo turno"
        />
      )}
      {cargando && <LoadingBackdrop visualizar={cargando} />}
      <CustomToast
        openToast={openToast}
        onDidDismiss={() => setOpenToast(false)}
        message={toastMessage}
        colorNotificacion={toastColor}
      />
    </>
  );
}

export default NuevoTurno;
